import { Box, Button, SxProps } from "@mui/material";
import { useState } from "react";

import { theme } from "../mui-customs/Theme";
import Typography from "./Typography";

interface ExpandableTextProps {
  text: string;
  charLimit: number;
  sx?: SxProps;
}

const ExpandableText = ({ text, charLimit, sx }: ExpandableTextProps) => {
  const [showMore, setShowMore] = useState(false);
  return (
    <Box sx={{ ...sx }}>
      <Typography variant="body5" sx={{ color: theme.black[800] }}>
        {showMore ? text : `${text.substring(0, charLimit)}`}
        {text.length > charLimit && (
          <Button
            onClick={() => setShowMore(!showMore)}
            sx={{
              textTransform: "none",
              color: theme.blue[400],
              py: 0,
              ":hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            {showMore ? "Read less" : "Read more"}
          </Button>
        )}
      </Typography>
    </Box>
  );
};

export default ExpandableText;
